import ms from 'ms';
import { useQuery } from 'react-query';

import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

export const useTopFilters = (config) => {
  const { data: { top: filters = [] } = {} } = useQuery(
    ['filters', config.filters_path],
    () => axios.get(config.filters_path).then(({ data }) => data),
    {
      enabled: config.type === 'events',
      staleTime: ms('10m'),
    },
  );

  if (config.staticFilters) return config.staticFilters;

  return { top: filters, overlay: [] };
};
